import { Link } from "react-router-dom";
import { ArrowLeft, MapPin } from "lucide-react";
import { PageHeader, Card, EmptyState } from "../components/ui";
import { AREA_SEGMENT, NAV_BY_ROLE } from "../components/nav";
import { useAuth } from "../hooks/useAuth";

export function NotFoundPage() {
  return (
    <div className="auth-shell">
      <Card className="auth-card">
        <div className="auth-card-head">
          <h1>404</h1>
          <p className="muted">Halaman tidak ditemukan.</p>
        </div>
        <Link to="/" className="btn btn-primary btn-block">
          Kembali ke beranda
        </Link>
      </Card>
    </div>
  );
}

export function ComingSoon({ title, hint }: { title: string; hint?: string }) {
  return (
    <div>
      <PageHeader title={title} />
      <EmptyState
        title="Fitur sedang disiapkan."
        hint={hint ?? "Bagian ini akan segera hadir."}
      />
    </div>
  );
}

/** Halaman Menu (mobile) — daftar semua menu area role. */
export function MenuPage() {
  const { user } = useAuth();
  if (!user) return null;
  const items = NAV_BY_ROLE[user.role];
  const segment = AREA_SEGMENT[user.role];
  return (
    <div>
      <PageHeader title="Menu" subtitle={user.fullName} />
      <div className="menu-grid">
        {items.map((item) => (
          <Link key={item.to} to={item.to} className="card menu-card">
            <item.icon size={20} />
            <span>{item.label}</span>
          </Link>
        ))}
        <Link to={`/${segment}/profile`} className="card menu-card">
          <MapPin size={20} />
          <span>Profil</span>
        </Link>
      </div>
    </div>
  );
}

/** Placeholder halaman tenant publik (wizard booking ada di Task 3.8). */
export function PublicTenantPage() {
  return (
    <div className="auth-shell">
      <div className="container">
        <Link to="/" className="back-link">
          <ArrowLeft size={16} /> Kembali
        </Link>
        <EmptyState
          title="Halaman lokasi sedang disiapkan."
          hint="Pilih layanan, terapis, dan jadwal — segera hadir."
        />
      </div>
    </div>
  );
}
